module.exports = "\n.mat-tab-label {\n    color: white !important;\n    opacity: 1 !important;\n}\n"